export default "__VITE_ASSET__CZsKn9va__"